module.exports = __webpack_public_path__ + "fonts/Adelle_HeavyItalic.d324247c.woff";